import { ServerApiService } from './server-api.service';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ContactService extends ServerApiService {
  protected baseUrl = 'https://www.raduanastase.com/fb-api/wp-json/contact-form-7/v1/contact-forms/548/feedback';

  sendEmail(name: string, email: string, subject: string, message: string): Observable<object> {
    const formData = new FormData();
    formData.set('your-name', name);
    formData.set('your-email', email);
    formData.set('your-subject', subject);
    formData.set('your-message', message);
    return this.http.post(this.baseUrl, formData);
  }
}
